import { styled } from '@mui/system';
import { Typography } from '@mui/material';

const RootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  margin: '12px 0 0 0',
  backgroundColor: '#FFFFFF',
  padding: '12px 15px',
  border: '1px solid #EAEAEA',
  borderRadius: '10px',
});

const HorizontalLineFull = styled('div')({
  width: 'calc(100% + 30px)',
  margin: '12px 0 12px -15px',
  height: '1px',
  backgroundColor: '#EAEAEA',
});

const AddOptionText = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: '500',
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '0.16px',
  color: '#0A7ABE',
  marginLeft: '27px',
});

const LocalTitleText = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: '600',
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#414046',
});

const SelectPayment = styled('select')({
  maxWidth: '306px',
  height: '40px',
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '19.5px',
  letterSpacing: '0.15px',
  color: '#757475',
  padding: '7px 0 7px 10px',
});

const SelectPaymentOption = styled('option')({
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '19.5px',
  letterSpacing: '0.15px',
  color: '#757475',
  padding: '7px 0 7px 10px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#0A7ABE',
    color: 'black',
  },
});

const TransferDiv = styled('div')({
  backgroundColor: '#F9F9F9',
  padding: '15px 12px',
  maxWidth: '304px',
  marginTop: '10px',
});
const TransferTitleText = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '19.5px',
  letterSpacing: '0.15px',
  color: '#414046',
  marginBottom: '6px',
});
const TransferText = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '0.15px',
  color: '#414046',
});
const MixDiv = styled('div')({
  display: 'flex',
  maxWidth: '304px',
  flexDirection: 'row',
  marginTop: '10px',
  alignItems: 'center',
  justifyContent: 'space-between',
});
const MixText = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: '600',
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '0.16px',
  color: '#414046',
});
const MixInput = styled('input')({
  maxWidth: '152px',
  padding: '10px',
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '0.15px',
  color: '#414046',
  textAlign: 'right',
});
const MixAmount = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: '500',
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '0.16px',
  color: '#757475',
});

const TotalTypography = styled(Typography)({
  fontFamily: 'Poppins',
  marginTop: '10px',
  marginLeft: '5px',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: '#757475',
  textAlign: 'right',
});

export {
  RootDiv,
  HorizontalLineFull,
  AddOptionText,
  LocalTitleText,
  SelectPayment,
  SelectPaymentOption,
  TransferDiv,
  TransferTitleText,
  TransferText,
  MixDiv,
  MixText,
  MixInput,
  MixAmount,
  TotalTypography,
};
